const SECS_IN_M = 60
const SECS_IN_H = 60 * 60
const SECS_IN_D = 60 * 60 * 24
const SECS_IN_W = 60 * 60 * 24 * 7

// @ts-expect-error TS(7006) FIXME: Parameter 'from' implicitly has an 'any' type.
export default function formatTimeAgo(from, now, shortened = true) {
  if (!from || !now) return null

  const dateFrom = from instanceof Date ? from : new Date(from)
  const dateNow = now instanceof Date ? now : new Date(now)

  // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
  const seconds = Math.round((dateNow - dateFrom) / 1000)

  // NOTE: For engage we only format days based on:
  // - 'seconds' or 's'
  // - 'minutes' or 'm'
  // - 'hours' or 'h'
  // - 'days' or 'd'
  // - 'weeks' or 'w'
  // We do not format based on 'months' or 'years' for now.

  let ammount = seconds
  let measure = 'second'

  if (seconds >= SECS_IN_W) {
    ammount = Math.floor(seconds / SECS_IN_W)
    measure = 'week'
  } else if (seconds >= SECS_IN_D) {
    ammount = Math.floor(seconds / SECS_IN_D)
    measure = 'day'
  } else if (seconds >= SECS_IN_H) {
    ammount = Math.floor(seconds / SECS_IN_H)
    measure = 'hour'
  } else if (seconds >= SECS_IN_M) {
    ammount = Math.floor(seconds / SECS_IN_M)
    measure = 'minute'
  }

  let suffix = null
  if (shortened) {
    suffix = measure.substring(0, 1)
  } else {
    const measureStr = ammount === 1 ? measure : `${measure}s`
    suffix = ` ${measureStr} ago`
  }

  return `${ammount}${suffix}`
}
